import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const Ellipsis = forwardRef(({ text = null, limit = 100 }, forwardedRef) => (
  <span ref={forwardedRef}>{text?.length > limit ? `${text?.substr(0, limit)}...` : text}</span>
));

Ellipsis.propTypes = {
  text: PropTypes.string,
  limit: PropTypes.number
};

export { Ellipsis };
